<!--
 * @Author: czj
 * @Date: 2025-04-11 15:13:47
 * @Description: 
 * @FilePath: \sanshu-report-new\src\components\ContentCom\comps\LineForm.vue
-->
<template>
  <div class="curtom_form">
    <el-form :label-position="'top'" :model="formValues" v-if="true">
      <template v-for="(item, index) in props.filtered_data" :key="index">
        <!-- 这是连线参数，只显示分组字段 和 比较方案字段，其余全部隐藏，这两个也字段禁止输入 -->
        <el-form-item v-if="item.category=='metadata' || item.category=='comparison_group_plan'">
          <template #label>
            <div class="label_text_box">{{ item.title || item.key }}</div>
            <el-popover placement="top-start" title="说明" width="200" trigger="hover" :content="item.description">
              <template #reference>
                <el-icon style="vertical-align: middle;">
                  <InfoFilled />
                </el-icon>
              </template>
            </el-popover>
          </template>

          <div class="flex line_item" style="justify-content: space-between;">


            <!--  <div class="flex file_name_box" v-if="false">
              <span class="ellipsis text_box">{{getFileName(formValues[item.key])}}</span>
              <el-icon class="copy_btn" @click="copyText(formValues[item.key])" title="复制文件路径"
                v-if="taskStore.template_config?.is_report_generation">
                <DocumentCopy />
              </el-icon>
            </div> -->

            <!--  <el-select v-model="formValues[item.key]" placeholder="请选择" class="select_box" size="large"
              @visible-change="(isVisible)=>{handleVisibleChange(item,isVisible)}" @change="handleSelectChange(item)">
              <template v-for="item in formSelects[item.key]" :key="item.value">
                <el-option :label="item.label" :value="item.value" />
              </template>
            </el-select> -->
            <el-button size="large" style="border-radius: 30px;" v-if="item.category=='metadata'"
              @click="openGroupSetting(item)" :loading="is_file_loading">分组设置</el-button>
            <el-button size="large" style="border-radius: 30px;" v-if="item.category=='comparison_group_plan'"
              @click="openComparisonSetting(item)" :loading="is_file_loading">比较方案</el-button>
          </div>
        </el-form-item>
        <el-form-item v-else-if="item.is_show">
          <template #label>
            <div class="label_text_box">{{ item.title || item.key }}</div>
            <el-popover placement="top-start" title="说明" width="200" trigger="hover" :content="item.description">
              <template #reference>
                <el-icon style="vertical-align: middle;">
                  <InfoFilled />
                </el-icon>
              </template>
            </el-popover>
          </template>
          <el-select v-model="formValues[item.key]" placeholder="请选择"
            @visible-change="(isVisible)=>{handleVisibleChange(item,isVisible)}" @change="handleSelectChange(item)">
            <template v-for="item in formSelects[item.key]" :key="item.value">
              <el-option :label="item.label" :value="item.value" />
            </template>
          </el-select>

        </el-form-item>


      </template>
    </el-form>

    <!-- <el-form :label-position="'top'" :model="formValues">
      <template v-for="(item, index) in props.filtered_data" :key="index">
        <el-form-item>
          <template #label>
            <div class="label_text_box">{{ item.title || item.key }}</div>
            <el-popover placement="top-start" title="说明" width="200" trigger="hover" :content="item.description">
              <template #reference>
                <el-icon style="vertical-align: middle;">
                  <InfoFilled />
                </el-icon>
              </template>
            </el-popover>
          </template>
          <el-select v-model="formValues[item.key]" placeholder="请选择"
            @visible-change="(isVisible)=>{handleVisibleChange(item,isVisible)}" @change="handleSelectChange(item)">
            <template v-for="item in formSelects[item.key]" :key="item.value">
              <el-option :label="item.label" :value="item.value" />
            </template>
          </el-select>
        </el-form-item>
      </template>
    </el-form> -->



    <el-dialog title="分组设置" v-model="is_group_dialog" width="80%" :close-on-click-modal="false">
      <SampleGroup v-if="is_group_dialog" ref="sampleGroups" :rawData="compare_group" :configData="configData"
        @updateCompareGroup="updateCompareGroup"></SampleGroup>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_group_dialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSaveGroup">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="比较方案" v-model="is_plan_dialog" width="80%" top="50px" :close-on-click-modal="false">
      <ComparePlan v-if="is_plan_dialog" ref="comparePlan" :rawData="compare_group" :compareData="compare_plan"
        :configData="configData" @updateComparePlan="updateComparePlan"></ComparePlan>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_plan_dialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSavePlan">确 定</el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';
  import { ElMessage } from 'element-plus';
  import { useStore } from '@/Store/index.js';
  import { transformData } from '@/utils/tool.js';
  import { get_associated_nodes_list, get_file_data, write_file_data } from '@/api/index.js';

  import SampleGroup from "@/components/ComparisonGroup/SampleGroup.vue";
  import ComparePlan from "@/components/ComparisonGroup/ComparePlan.vue";
  import { useTaskStore } from "@/Store/task.js";



  const store = useStore();
  const emit = defineEmits(['change'])
  const props = defineProps(['filtered_data', 'raw_item']);

  const taskStore = useTaskStore();

  const formValues = ref({});//表单值
  const formSelects = ref({});//下拉列表
  const current_key = ref(null);// 当前选中项的key
  const is_dialog = ref(false);// 是否是弹窗模式
  const node_data_token = ref(null);// 节点数据token


  const table_data = ref(null); // 表格数据
  const plan_data = ref(null); // 方案数据

  const compare_group = ref(null);// 存储比较组数据
  const compare_plan = ref(null);//比较方案

  const is_file_loading = ref(false);// 是否正在读取文件

  const is_group_dialog = ref(false); // 是否显示分组对话框
  const is_plan_dialog = ref(false); // 是否显示方案对话框

  const configData = ref({});// 存储配置数据
  const metadata_file_path = ref('');// 存储分组文件路径
  const control_file_path = ref('');// 存储控制文件路径

  const sampleGroups = ref(null);// 分组组件实例
  const comparePlan = ref(null);// 比较方案组件实例


  const testFunc = function () {
    console.log("连线表单", props.filtered_data);
  };

  const initFunc = () => {
    props.filtered_data.forEach(item => {
      // formValues.value[item.key] = '';
      formValues.value[item.key] = item.default || '';
      formSelects.value[item.key] = [];
    });
  };

  const handleVisibleChange = function (item, isVisible) {
    if (isVisible) {
      getAssociatedNodesList(item);
    }
  };

  const getAssociatedNodesList = function (item) {
    const task_id = store.task_id;
    if (task_id) {
      const params = {
        "task_id": task_id,
        "input": item.value
      };
      get_associated_nodes_list(params).then((result) => {
        if (result.data) {
          formSelects.value[item.key] = transformData(result.data);
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  };

  const saveinput = function (val) {
    if (val) formValues.value[current_key.value] = val;
    dialogVisible.value = false;
  };

  const handleSelectChange = function (item) {
    const { associate_config } = item;
    const select_val = formValues.value[item.key];
    emit('change', { select_val, ...item });
  };

  // 处理原始数据,转为对象数组
  const getTableData = (rawData) => {
    const { columns, data } = rawData;
    return data.map(row => {
      let rowObject = {};
      row.forEach((cell, index) => {
        rowObject[columns[index]] = cell;  // 根据索引将数据和列名对应
      });
      return rowObject;
    });
  };

  //根据路径读取文件
  /*  const readFileByPath = function (path, type) {
     const file_path = path;
     const params = {
       "callback_name": "file_path",
       "file_path": file_path,
       "callback_function": {
         "file_format": "table"
       }
     };
     is_file_loading.value = true;
     get_file_data(params).then((result) => {
       if (type == 'group') {
         table_data.value = result.data; // 存储分组数据
         console.log("分组数据数据格式", result);
         compare_group.value = getTableData(result.data); // 转为对象数组
       } else if (type == 'plan') {
         plan_data.value = result.data; // 存储方案数据
         compare_plan.value = getTableData(result.data); // 转为对象数组
         console.log("比较方案表格数据", plan_data.value);
       };
       is_file_loading.value = false;
     }).catch((err) => {
       console.error('读取文件失败', err);
       is_file_loading.value = false;
     });
   }; */


  const readFileByPath = async function (path, type) {
    const file_path = path;
    const params = {
      "callback_name": "file_path",
      "file_path": file_path,
      "callback_function": {
        "file_format": "table"
      }
    };
    is_file_loading.value = true;
    try {
      const result = await get_file_data(params);
      if (type === 'group') {
        table_data.value = result.data;
        compare_group.value = getTableData(result.data);
      } else if (type === 'plan') {
        plan_data.value = result.data;
        compare_plan.value = getTableData(result.data);
      }
      return result;
    } catch (err) {
      console.error('读取文件失败', err);
      throw err; 抛出
    } finally {
      is_file_loading.value = false;
    }
  };



  /*   const openGroupSetting = function (item) {
      //打开分组设置
      //利用 PubSub 发送消息
      //  PubSub.publish('group_setting', { type: "group" });
      console.log("当前分组文件item", item);
      //判断是否存在文件路径
      const file_path = formValues.value[item.key];
      console.log("当前分组文件值", file_path);
      configData.value = item?.ComparisonGroup;
      if (file_path) readFileByPath(file_path, 'group'); // 读取文件
    }; */

  /*   const openComparisonSetting = function (item) {
    //打开比较方案设置
    //  PubSub.publish('group_setting', { type: "comparison" });
    console.log("当前比较方案item", item);
    const file_path = formValues.value[item.key];
    console.log("当前方案文件值", file_path);
    configData.value = item?.ComparisonGroup;
    if (file_path) readFileByPath(file_path, 'plan'); // 读取文件
  }; */


  const openGroupSetting = async function (item) {
    // 打开分组设置
    console.log("当前分组文件 item", item);
    // 判断是否存在文件路径
    const file_path = formValues.value[item.key];
    console.log("当前分组文件值", formValues.value, file_path);
    configData.value = item?.ComparisonGroup;
    metadata_file_path.value = file_path;
    if (file_path) {
      try {
        const result = await readFileByPath(file_path, 'group');
        console.log("分组文件读取完成:", result);


        compare_group.value = getTableData(table_data.value);
        setTimeout(() => { is_group_dialog.value = true; }, 300);

      } catch (err) {
        console.error("读取分组文件失败:", err);
      }
    }
  };


  const openComparisonSetting = async function (item) {
    // 打开比较方案设置
    console.log("当前比较方案 item", item);
    const file_path = formValues.value[item.key];
    console.log("当前方案文件值", file_path);
    configData.value = item?.ComparisonGroup;
    control_file_path.value = file_path;

    metadata_file_path.value = item?.ComparisonGroup?.sampletsv;

    if (file_path && metadata_file_path.value) {
      try {
        const result2 = await readFileByPath(metadata_file_path.value, 'group');
        const result1 = await readFileByPath(file_path, 'plan');
        console.log("比较方案文件读取完成:", result2);
        console.log("分组文件读取完成:", result2);

        setTimeout(() => { is_plan_dialog.value = true; }, 300);

      } catch (err) {
        console.error("读取比较方案文件失败:", err);
      }
    } else {
      ElMessage.error('未找到分组文件，请先设置分组文件路径');
    }
  };

  // 处理比较数据
  const getCompareTableData = (arr, columns) => {
    if (arr.length === 0) return { columns, data: [] };
    // 获取数据，按照传入的 columns 顺序
    const data = arr.map(item => columns.map(column => item[column]));
    return { columns, data };
  };
  //更新文件数据
  const updateFileData = function (path, data) {
    const file_path = path;
    const params = {
      "callback_name": "file_path",
      "file_path": file_path,
      "callback_function": {
        "type": "table"
      },
      "data": data
    };
    write_file_data(params).then((result) => {
      if (result.code == 200) {
        ElMessage.success('更新成功');
        //更改组名后请到比较方案中进行相应调整，否则可能会运行失败
        // ElMessage.warning('更改组名后请到比较方案中进行相应调整，否则可能会运行失败');
        ElMessage.warning({
          message: '更改组名后请到比较方案中进行相应调整，否则可能会运行失败',
          duration: 5000 // 显示 5 秒
        })
      }
    }).catch((err) => {
      console.error('更新文件失败', err);
    });
  };
  // 分组组件回调
  const updateCompareGroup = function (data) {
    compare_group.value = data;
    const result = getCompareTableData(data, table_data.value.columns);
    table_data.value = result;
    updateFileData(metadata_file_path.value, result); // 更新文件数据
    is_group_dialog.value = false; // 关闭对话框
  };
  // 保存分组数据
  const handleSaveGroup = function () {
    if (sampleGroups.value) sampleGroups.value.updateHandle();
  };
  // 比较方案组件回调
  const updateComparePlan = function (data) {
    const result = getCompareTableData(data, plan_data.value.columns);
    plan_data.value = result;
    updateFileData(control_file_path.value, result); // 更新文件数据
    is_plan_dialog.value = false; // 关闭对话框
  };
  // 保存方案数据
  const handleSavePlan = function () {
    if (comparePlan.value) comparePlan.value.updateHandle();
  };


  //处理文件路径，只展示文件名称
  function getFileName(path) {
    if (!path) return '';
    return path.split('/').pop();
  };

  //复制文本
  const copyText = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    ElMessage.success("复制成功！");
  };

  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
    initFunc();
  });
  //组件已经挂载
  onMounted(() => {
    if (props.raw_item) {
      node_data_token.value = PubSub.subscribe(props.raw_item.title, function (msg, data) {
        if (!data.inputs_json) {
          console.error(`${props.raw_item.title},当前节点连线表单没有输入数据`, data);
          return;
        };
        let keys = Object.keys(data.inputs_json);
        keys.forEach(key => {
          if (formValues.value.hasOwnProperty(key)) {
            formValues.value[key] = data.inputs_json[key];
          }
        })
      })
    };
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);//取消订阅
  });
  //组件已经卸载
  onUnmounted(() => {
  });
  defineExpose({
    formValues
  })
</script>
<style scoped>
  .form_unit_label {
    height: 32px;
    line-height: 32px;
  }

  .label_text_box {
    display: inline-block;
    vertical-align: middle;
    max-width: calc(100% - 50px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 5px;
  }


  .el-collapse-item__header {
    padding-left: 10px;
  }

  .cell_container .el-select {
    width: 100%;
  }

  .collapse_head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .collapse_h_left .header-icon {
    font-size: 1.3rem;
    vertical-align: middle;
  }

  .collapse_h_left span {
    vertical-align: middle;
  }

  .line_item {
    width: 100%;
  }

  .select_box {
    width: 80% !important;
  }

  .file_name_box {
    height: 40px;
    line-height: 40px;
    border-radius: var(--el-border-radius-base);
    background-color: var(--el-fill-color-light);

    padding: 0 16px;
    box-sizing: border-box;
    box-shadow: 0 0 0 1px var(--el-border-color-hover) inset;
    width: calc(100% - 110px);
    justify-content: space-between;
    overflow: hidden;

    .text_box {
      display: inline-block;
      max-width: calc(100% - 100px);
    }

    .copy_btn {
      cursor: pointer;
    }
  }
</style>
<style>
  /* 自定义表单样式 */

  .curtom_form .el-form--label-top .el-form-item__label {
    width: 100%;
    line-height: normal;
    display: block;
    padding: 0 !important;
  }
</style>